export default __webpack_public_path__ + "static/media/team_shuffle_shuffle.f16195c4.mp3";